export default __webpack_public_path__ + "static/media/Quiken_Contacto.4b0d65b5.png";